import type { AddOnResponse } from "@bookingkit/api-v4/models/add-on-response";
import { AddOn } from "@/services/InventoryService/types";
import InventoryServiceError from "@/services/InventoryService/Errors/InventoryServiceError";
import { i18n } from "@/i18nSetup";

type Translation = { locale?: string, text?: string };

const toLanguage = (locale: string): string => locale.split('-')[0].toLowerCase();

export const pickTranslation = (translations: Translation[] | undefined, locale: string): string => {
    const language = toLanguage(locale);
    const match = translations?.find(
        (translation) => translation.locale && toLanguage(translation.locale) === language
    );

    return match?.text ?? translations?.[0]?.text ?? '';
}

export const fromApiToAddOn = (fromApiModelInput: AddOnResponse): AddOn => {
    const {
        id, name, description, active, image_url, cancellation_policy_ids
    } = fromApiModelInput;

    if (typeof id !== 'string') {
        throw InventoryServiceError.fromInvalidProperty('id', 'string', id);
    }

    if (!Array.isArray(name)) {
        throw InventoryServiceError.fromInvalidProperty('name', 'array', name);
    }

    const locale = String(i18n.global.locale.value);

    return {
        id,
        title: pickTranslation(name, locale),
        description: pickTranslation(description, locale),
        active: active ?? true,
        imageUrl: image_url,
        cancellationPolicyIds: cancellation_policy_ids ?? []
    }
}

export default { fromApiToAddOn };
